import { QuerySwitch } from 'components/QuerySwitch';
import { DetailTabView } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailTabView/DetailTabView';
import { FC } from 'react';
import { IDetailViewComponentProps } from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/DetailView.types';
import {
  OpenShiftModalDataProvider,
  OpenShiftModalDataContext,
} from 'pages/LocationSettingsPage/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/OpenShiftModalProvider.data.context';

export const DetailViewComponent: FC<IDetailViewComponentProps> = (values) => {
  return <DetailTabView {...values} />;
};

export const DetailView: FC = () => {
  return (
    <OpenShiftModalDataProvider>
      <QuerySwitch component={DetailViewComponent} context={OpenShiftModalDataContext} />
    </OpenShiftModalDataProvider>
  );
};
